import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  cell: {
    height: 40,
  },
}));

export default useStyles;
